const translator = {
	rus: 'Татьяна Аудерская'
};
export default translator;